/**
 * @generated SignedSource<<e2a39d7ef4f0e1e2e9fb23e375e490ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CheckSisenseSeatsInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CheckSisenseSeatsMutation$variables = {
  input: CheckSisenseSeatsInput;
};
export type CheckSisenseSeatsMutation$data = {
  readonly checkSisenseSeats: {
    readonly designerSeats: number | null;
    readonly viewerSeats: number | null;
  } | null;
};
export type CheckSisenseSeatsMutation = {
  variables: CheckSisenseSeatsMutation$variables;
  response: CheckSisenseSeatsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CheckSisenseSeatsPayload",
    "kind": "LinkedField",
    "name": "checkSisenseSeats",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "designerSeats",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "viewerSeats",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckSisenseSeatsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CheckSisenseSeatsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8f978b826638f0e5c86cba54b97eaa74",
    "id": null,
    "metadata": {},
    "name": "CheckSisenseSeatsMutation",
    "operationKind": "mutation",
    "text": "mutation CheckSisenseSeatsMutation(\n  $input: CheckSisenseSeatsInput!\n) {\n  checkSisenseSeats(input: $input) {\n    designerSeats\n    viewerSeats\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0d9089fcb410601c2c885c175054ca7";

export default node;
